module.exports = __webpack_public_path__ + "media/images/syntax/ud53-54-acdaae113de1d028246e019f88b1f533.png";